import React, { useEffect, useMemo, useState } from 'react';
import imageCompression from 'browser-image-compression';
import heic2any from 'heic2any';
import { QRCodeSVG } from 'qrcode.react';
import api from '../../services/api';

const Icons = {
  User: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
  MapPin: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>,
  Glasses: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="6" cy="10" r="2"/><circle cx="18" cy="10" r="2"/><path d="M2 10s2-2 4-2c2 0 4 2 4 2s2-2 4-2 4 2 4 2"/></svg>,
  Search: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  Camera: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>,
  FileText: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>,
  Dollar: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
  Building: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M9 6h6M9 10h6M9 14h6M9 18h6"/></svg>,
  Phone: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.8 12.8 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.8 12.8 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>,
  Message: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 1 1-7.6-13.5h.8c4.3 0 7.9 3.5 7.7 7.7z"/></svg>,
  Plus: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  Trash: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>,
  Copy: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>,
  Smartphone: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>,
  Alert: () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>,
  
  // Formatos de Armação
  ShapeRound: () => <svg width="24" height="12" viewBox="0 0 40 20" fill="none" stroke="currentColor" strokeWidth="2.5"><circle cx="10" cy="10" r="7"/><circle cx="30" cy="10" r="7"/><path d="M17 10h6"/></svg>,
  ShapeSquare: () => <svg width="24" height="12" viewBox="0 0 40 20" fill="none" stroke="currentColor" strokeWidth="2.5"><rect x="3" y="3" width="14" height="14" rx="2"/><rect x="23" y="3" width="14" height="14" rx="2"/><path d="M17 10h6"/></svg>,
  ShapeRect: () => <svg width="24" height="12" viewBox="0 0 40 20" fill="none" stroke="currentColor" strokeWidth="2.5"><rect x="2" y="5" width="16" height="10" rx="2"/><rect x="22" y="5" width="16" height="10" rx="2"/><path d="M18 10h4"/></svg>,
  ShapeOval: () => <svg width="24" height="12" viewBox="0 0 40 20" fill="none" stroke="currentColor" strokeWidth="2.5"><ellipse cx="10" cy="10" rx="8" ry="6"/><ellipse cx="30" cy="10" rx="8" ry="6"/><path d="M18 10h4"/></svg>,
  ShapeAviator: () => <svg width="24" height="12" viewBox="0 0 40 20" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M3 8c0-3 3-5 7-5 5 0 7 5 7 9 0 4-4 5-7 5-4 0-7-2-7-9z"/><path d="M23 8c0-3 3-5 7-5 5 0 7 5 7 9 0 4-4 5-7 5-4 0-7-2-7-9z"/><path d="M17 6h6"/></svg>,
  ShapeCat: () => <svg width="24" height="12" viewBox="0 0 40 20" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M2 6l5-4c4 0 9 4 9 9 0 4-4 5-7 5-4 0-7-3-7-10z"/><path d="M22 6l5-4c4 0 9 4 9 9 0 4-4 5-7 5-4 0-7-3-7-10z"/><path d="M16 8h8"/></svg>,
};

const itemPadrao = {
  paciente: '',
  receita: {
    od: { esf: '', cil: '', eixo: '', dnp: '', aco: '' },
    oe: { esf: '', cil: '', eixo: '', dnp: '', aco: '' },
    adicao: ''
  },
  lente: '',
  armacao: '',
  cv: '',
  medidasArmacao: { aro: '', ponte: '', altura: '', diagonalMaior: '' },
  origemArmacao: 'Ótica',
  envioArmacao: 'Vai no malote',
  formatoArmacao: ''
};

const masks = {
  cpf: (v) => v.replace(/\D/g, '').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d{1,2})/, '$1-$2').replace(/(-\d{2})\d+?$/, '$1'),
  cep: (v) => v.replace(/\D/g, '').replace(/^(\d{5})(\d)/, '$1-$2').slice(0, 9),
  phone: (v) => v.replace(/\D/g, '').replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2').slice(0, 15)
};

const formatters = {
  esf: (v) => { if (!v) return ''; const n = parseFloat(v.replace(',', '.')); return isNaN(n) ? v : `${n >= 0 ? '+' : ''}${n.toFixed(2).replace('.', ',')}`; },
  cil: (v) => { if (!v) return ''; const n = parseFloat(v.replace(',', '.')); return isNaN(n) ? v : `-${Math.abs(n).toFixed(2).replace('.', ',')}`; },
  eixo: (v) => { const n = parseInt(v); return isNaN(n) ? '' : `${Math.min(Math.max(n, 0), 180)}º`; },
  adicao: (v) => { if (!v) return ''; const n = parseFloat(v.replace(',', '.')); return isNaN(n) ? v : `+${Math.abs(n).toFixed(2).replace('.', ',')}`; }
};

const parseMoney = (val) => {
  if (!val) return 0;
  let v = String(val).replace(/[^0-9,.]/g, '').replace(',', '.');
  return isNaN(parseFloat(v)) ? 0 : parseFloat(v);
};

const formatCurrency = (v) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);

function SectionTitle({ icon, title, subtitle }) {
  return (
    <div style={styles.sectionTitleWrap}>
      <div style={styles.sectionIcon}>{icon}</div>
      <div>
        <div style={styles.sectionTitle}>{title}</div>
        {subtitle ? <div style={styles.sectionSubtitle}>{subtitle}</div> : null}
      </div>
    </div>
  );
}

function Field({ label, required, error, children, span2 }) {
  return (
    <div
      style={{
        ...styles.fieldWrap,
        ...(span2 ? styles.span2 : {}),
        ...(error ? styles.fieldWrapError : {})
      }}
    >
      <label style={{ ...styles.label, ...(error ? styles.labelError : {}) }}>
        {label} {required ? <span style={{ color: '#ef4444' }}>*</span> : null}
      </label>
      {children}
    </div>
  );
}

function ReceitaRow({ label, color, values, baseIndex, onChange, onEnter }) {
  return (
    <div style={styles.receitaRow}>
      <div style={{ ...styles.olhoBadge, background: color }}>{label}</div>
      {['esf', 'cil', 'eixo', 'dnp', 'aco'].map((field, i) => (
        <input
          key={field}
          data-idx={baseIndex + i}
          value={values[field] || ''}
          onChange={(e) => onChange(field, e.target.value)}
          onBlur={(e) => onChange(field, formatters[field] ? formatters[field](e.target.value) : e.target.value)}
          onKeyDown={(e) => onEnter(e, baseIndex + i)}
          style={styles.tdInput}
          placeholder={field === 'eixo' ? '0º' : '0,00'}
        />
      ))}
    </div>
  );
}

export default function OSForm({ onCancel, onSuccess }) {
  const todayStr = new Date().toLocaleDateString('pt-BR').split('/').reverse().join('-');
  const statusOptions = ['Pedido da lente', 'Pedido realizado', 'No laboratório', 'Pronto na loja', 'Entregue'];
  const metodosPagamento = ['Dinheiro', 'PIX', 'Débito', 'Crédito'];

  const [empresas, setEmpresas] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [loadingEmpresas, setLoadingEmpresas] = useState(false);
  const [loadingUsuarios, setLoadingUsuarios] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingCep, setLoadingCep] = useState(false);

  const [armacaoSuggestions, setArmacaoSuggestions] = useState([]);
  const [lenteSuggestions, setLenteSuggestions] = useState([]);
  const [showSuggestionsIndex, setShowSuggestionsIndex] = useState(null);
  const [showLenteSuggestionsIndex, setShowLenteSuggestionsIndex] = useState(null);
  const [isSearchingStock, setIsSearchingStock] = useState(false);
  const [isSearchingLente, setIsSearchingLente] = useState(false);

  const [compressing, setCompressing] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadMessage, setUploadMessage] = useState('');

  const [qrSessionId, setQrSessionId] = useState(null);
  const [showQRModal, setShowQRModal] = useState(false);

  const [errors, setErrors] = useState({});

  const [form, setForm] = useState({
    loja: '',
    vendedor: '',
    cliente: '',
    cpf: '',
    dataNascimento: '',
    whatsapp: '',
    cep: '',
    endereco: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    uf: '',
    dataCompra: todayStr,
    dataEntrega: '',
    itens: [JSON.parse(JSON.stringify(itemPadrao))],
    status: 'Pedido da lente',
    statusmsg: 'Pendente',
    novoTextoRegistro: '',
    anexos: ['', '', '', ''],
    valorTotal: '',
    pagamentos: []
  });

  const [novoPagamento, setNovoPagamento] = useState({
    metodo: 'Dinheiro',
    valor: '',
    parcelas: 1
  });

  const empresaSelecionada = useMemo(
    () => empresas.find((emp) => emp.codigoLoja === form.loja || emp._id === form.loja) || null,
    [empresas, form.loja]
  );

  const vendedoresDisponiveis = useMemo(() => {
    if (!form.loja) return [];
    return usuarios.filter((user) => {
      const ativo = user.ativo !== false;
      const mesmaLoja = String(user.loja || '').trim() === String(form.loja || '').trim();
      const tipoValido = ['vendedor', 'admin'].includes(String(user.tipo || '').toLowerCase());
      return ativo && mesmaLoja && tipoValido;
    });
  }, [usuarios, form.loja]);

  useEffect(() => {
    fetchEmpresas();
    fetchUsuarios();
  }, []);

  useEffect(() => {
    if (!form.loja && empresas.length > 0) {
      const primeiraAtiva = empresas.find((emp) => emp.ativo !== false) || empresas[0];
      setForm((prev) => ({ ...prev, loja: primeiraAtiva.codigoLoja }));
    }
  }, [empresas, form.loja]);

  useEffect(() => {
    if (!form.loja) return;
    const vendedorAindaExiste = vendedoresDisponiveis.some(
      (user) => user.nomeCompleto === form.vendedor
    );
    if (!vendedorAindaExiste) {
      const primeiro = vendedoresDisponiveis[0];
      setForm((prev) => ({ ...prev, vendedor: primeiro ? primeiro.nomeCompleto : '' }));
    }
  }, [form.loja, vendedoresDisponiveis, form.vendedor]);

  useEffect(() => {
    let interval;
    if (showQRModal && qrSessionId) {
      interval = setInterval(async () => {
        try {
          const response = await api.get(`/ordens-servico/api/sync-camera/${qrSessionId}`);
          if (response.data?.images?.length > 0) {
            setForm((prev) => {
              const newAnexos = [...prev.anexos];
              let imageIndex = 0;
              for (let i = 0; i < newAnexos.length; i++) {
                if (newAnexos[i] === '' && imageIndex < response.data.images.length) {
                  newAnexos[i] = response.data.images[imageIndex];
                  imageIndex++;
                }
              }
              while (imageIndex < response.data.images.length) {
                newAnexos.push(response.data.images[imageIndex]);
                imageIndex++;
              }
              return { ...prev, anexos: newAnexos };
            });
            setShowQRModal(false);
            setQrSessionId(null);
          }
        } catch {}
      }, 3000);
    }
    return () => clearInterval(interval);
  }, [showQRModal, qrSessionId]);

  const fetchEmpresas = async () => {
    setLoadingEmpresas(true);
    try {
      const response = await api.get('/empresas');
      setEmpresas(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Erro ao buscar empresas:', error);
    } finally {
      setLoadingEmpresas(false);
    }
  };

  const fetchUsuarios = async () => {
    setLoadingUsuarios(true);
    try {
      const response = await api.get('/users');
      setUsuarios(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Erro ao buscar usuários:', error);
    } finally {
      setLoadingUsuarios(false);
    }
  };

  const limparErro = (key) => {
    if (!errors[key]) return;
    setErrors((prev) => {
      const next = { ...prev };
      delete next[key];
      return next;
    });
  };

  const update = (path, value) => {
    limparErro(path);
    setForm((prev) => {
      const copy = JSON.parse(JSON.stringify(prev));
      const keys = path.split('.');
      let ref = copy;
      for (let i = 0; i < keys.length - 1; i++) ref = ref[keys[i]];
      ref[keys[keys.length - 1]] = value;
      return copy;
    });
  };

  const updateItem = (index, path, value) => {
    const errorKey =
      path === 'paciente'
        ? `item_${index}_paciente`
        : path === 'lente'
          ? `item_${index}_lente`
          : path === 'armacao'
            ? `item_${index}_armacao`
            : null;

    if (errorKey) limparErro(errorKey);

    setForm((prev) => {
      const next = { ...prev };
      const itens = [...next.itens];
      const item = JSON.parse(JSON.stringify(itens[index]));
      const keys = path.split('.');
      let ref = item;
      for (let i = 0; i < keys.length - 1; i++) ref = ref[keys[i]];
      ref[keys[keys.length - 1]] = value;
      itens[index] = item;
      next.itens = itens;
      return next;
    });
  };

  const addNovoOculos = () => {
    setForm((prev) => ({
      ...prev,
      itens: [...prev.itens, JSON.parse(JSON.stringify(itemPadrao))]
    }));
  };

  const removerOculos = (index) => {
    if (!window.confirm('Deseja remover este óculos?')) return;
    setForm((prev) => ({
      ...prev,
      itens: prev.itens.filter((_, i) => i !== index)
    }));
  };

  const copiarDadosDoPrimeiroOculos = (index) => {
    setForm((prev) => {
      const itens = [...prev.itens];
      itens[index].paciente = prev.itens[0].paciente;
      itens[index].receita = JSON.parse(JSON.stringify(prev.itens[0].receita));
      return { ...prev, itens };
    });
  };

  const handleArmacaoSearch = async (text, index) => {
    updateItem(index, 'armacao', text);
    if (text.length < 2) {
      setArmacaoSuggestions([]);
      setShowSuggestionsIndex(null);
      return;
    }
    setIsSearchingStock(true);
    setShowSuggestionsIndex(index);
    try {
      const response = await api.get(`/api/armacoes?ref=${encodeURIComponent(text)}`);
      setArmacaoSuggestions(response.data.filter((item) => item.qtd > 0));
    } catch {
      setArmacaoSuggestions([]);
    } finally {
      setIsSearchingStock(false);
    }
  };

  const selectArmacao = (item, index) => {
    updateItem(index, 'armacao', `${item.marca} ${item.ref} (${item.cor})`);
    setShowSuggestionsIndex(null);
  };

  const handleLenteSearch = async (text, index) => {
    updateItem(index, 'lente', text);
    if (text.length < 2) {
      setLenteSuggestions([]);
      setShowLenteSuggestionsIndex(null);
      return;
    }
    setIsSearchingLente(true);
    setShowLenteSuggestionsIndex(index);
    try {
      const response = await api.get('/produtos');
      setLenteSuggestions(
        response.data.filter(
          (prod) =>
            prod.categoria === 'Lente' &&
            prod.nome.toLowerCase().includes(text.toLowerCase())
        )
      );
    } catch {
      setLenteSuggestions([]);
    } finally {
      setIsSearchingLente(false);
    }
  };

  const selectLente = (item, index) => {
    updateItem(index, 'lente', item.nome);
    setShowLenteSuggestionsIndex(null);
  };

  const checkCEP = async (e) => {
    const cep = e.target.value.replace(/\D/g, '');
    if (cep.length !== 8) return;
    setLoadingCep(true);
    try {
      const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await res.json();
      if (!data.erro) {
        setForm((prev) => ({
          ...prev,
          endereco: data.logradouro,
          bairro: data.bairro,
          cidade: data.localidade,
          uf: data.uf
        }));
      }
    } catch {
    } finally {
      setLoadingCep(false);
    }
  };

  const addPayment = () => {
    const val = parseMoney(novoPagamento.valor);
    if (val <= 0) return alert('Digite um valor válido.');
    setForm((prev) => ({
      ...prev,
      pagamentos: [
        ...prev.pagamentos,
        {
          id: Date.now(),
          metodo: novoPagamento.metodo,
          valor: val,
          parcelas: novoPagamento.metodo === 'Crédito' ? Number(novoPagamento.parcelas) : 1
        }
      ]
    }));
    setNovoPagamento({ metodo: 'Dinheiro', valor: '', parcelas: 1 });
  };

  const removePayment = (id) => {
    setForm((prev) => ({
      ...prev,
      pagamentos: prev.pagamentos.filter((p) => p.id !== id)
    }));
  };

  const openMobileCamera = () => {
    setQrSessionId(`os_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`);
    setShowQRModal(true);
  };

  const closeMobileCamera = () => {
    setQrSessionId(null);
    setShowQRModal(false);
  };

  const handleFileChange = async (index, file) => {
    if (!file) return;

    try {
      setCompressing(true);
      setUploadProgress(0);
      setUploadMessage('Analisando...');
      let fileToProcess = file;

      const fileExtension = file.name.split('.').pop().toLowerCase();
      const isHeic =
        file.type === 'image/heic' ||
        file.type === 'image/heif' ||
        fileExtension === 'heic' ||
        fileExtension === 'heif';

      if (isHeic) {
        setUploadMessage('Convertendo HEIC...');
        setUploadProgress(20);
        const convertedBlob = await heic2any({
          blob: file,
          toType: 'image/jpeg',
          quality: 0.8
        });
        const blob = Array.isArray(convertedBlob) ? convertedBlob[0] : convertedBlob;
        fileToProcess = new File(
          [blob],
          file.name.replace(/\.(heic|heif)$/i, '.jpg'),
          { type: 'image/jpeg' }
        );
        setUploadProgress(50);
      }

      setUploadMessage('Otimizando...');
      const finalFile = await imageCompression(fileToProcess, {
        maxSizeMB: 1,
        maxWidthOrHeight: 1280,
        useWebWorker: true,
        onProgress: (p) => setUploadProgress(isHeic ? 50 + p / 2 : p)
      });

      setUploadMessage('Finalizando...');
      const reader = new FileReader();
      reader.readAsDataURL(finalFile);
      reader.onloadend = () => {
        const newAnexos = [...form.anexos];
        newAnexos[index] = reader.result;
        setForm((prev) => ({ ...prev, anexos: newAnexos }));
        setTimeout(() => {
          setCompressing(false);
          setUploadProgress(0);
        }, 300);
      };
    } catch (error) {
      console.error(error);
      setCompressing(false);
      alert('Erro ao carregar imagem.');
    }
  };

  const addImageSlot = () => {
    setForm((prev) => ({ ...prev, anexos: [...prev.anexos, ''] }));
  };

  const removeImage = (index) => {
    const newAnexos = [...form.anexos];
    newAnexos[index] = '';
    setForm((prev) => ({ ...prev, anexos: newAnexos }));
  };

  const handleEnterNavigation = (e, currentIndex) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const nextInput = document.querySelector(`input[data-idx="${currentIndex + 1}"]`);
      if (nextInput) {
        nextInput.focus();
        nextInput.select();
      }
    }
  };

  const validateForm = () => {
    const next = {};
    if (!form.loja.trim()) next.loja = true;
    if (!form.vendedor.trim()) next.vendedor = true;
    if (!form.cliente.trim()) next.cliente = true;
    if (!form.whatsapp.trim()) next.whatsapp = true;
    if (!form.dataCompra) next.dataCompra = true;
    if (!form.dataEntrega) next.dataEntrega = true;

    form.itens.forEach((item, index) => {
      if (!item.paciente.trim()) next[`item_${index}_paciente`] = true;
      if (!item.lente.trim()) next[`item_${index}_lente`] = true;
      if (!item.armacao.trim()) next[`item_${index}_armacao`] = true;
    });

    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const valorTotalNum = parseMoney(form.valorTotal);
  const totalPago = form.pagamentos.reduce((acc, p) => acc + p.valor, 0);
  const restante = valorTotalNum - totalPago;
  const mobileCameraUrl = `${window.location.origin}/camera/${qrSessionId}`;

  const handleSubmit = async () => {
    if (compressing) return alert('Aguarde o processamento das imagens...');
    if (!validateForm()) {
      document.querySelector('.scroll-area')?.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    setLoading(true);
    try {
      const anexosFinais = form.anexos.filter(Boolean);

      const payload = {
        ...form,
        itens: form.itens.map((item) => ({
          paciente: { nome: item.paciente },
          receita: item.receita,
          produto: {
            lente: item.lente,
            armacao: item.armacao,
            numeroCV: item.cv,
            medidasArmacao: item.medidasArmacao,
            origemArmacao: item.origemArmacao,
            envioArmacao: item.envioArmacao,
            formatoArmacao: item.formatoArmacao
          }
        })),
        valorTotal: valorTotalNum,
        registroTexto: form.novoTextoRegistro,
        anexos: anexosFinais,
        cliente: {
          nome: form.cliente,
          cpf: form.cpf,
          dataNascimento: form.dataNascimento
        },
        endereco: {
          cep: form.cep,
          logradouro: form.endereco,
          numero: form.numero,
          complemento: form.complemento,
          bairro: form.bairro,
          cidade: form.cidade,
          uf: form.uf
        }
      };

      const response = await api.post('/ordens-servico', payload);
      onSuccess(response.data);
    } catch (err) {
      alert(err.response?.data?.error || 'Erro ao salvar O.S.');
    } finally {
      setLoading(false);
    }
  };

  const formatos = [
    { id: 'Redondo', label: 'Redondo', Icon: Icons.ShapeRound },
    { id: 'Quadrado', label: 'Quadrado', Icon: Icons.ShapeSquare },
    { id: 'Retangular', label: 'Retangular', Icon: Icons.ShapeRect },
    { id: 'Oval', label: 'Oval', Icon: Icons.ShapeOval },
    { id: 'Aviador', label: 'Aviador', Icon: Icons.ShapeAviator },
    { id: 'Gatinho', label: 'Gatinho', Icon: Icons.ShapeCat }
  ];

  return (
    <div
      style={styles.shell}
      onClick={() => {
        setShowSuggestionsIndex(null);
        setShowLenteSuggestionsIndex(null);
      }}
    >
      <style>{`
        @media (max-width: 920px) {
          .os-grid-2 { grid-template-columns: 1fr !important; }
          .os-grid-4 { grid-template-columns: 1fr 1fr !important; }
          .os-actions { flex-direction: column !important; }
          .os-actions button { width: 100%; }
          .os-finance { flex-direction: column !important; }
          .os-footer { flex-direction: column !important; }
          .os-footer button { width: 100%; }
          .os-header { flex-direction: column !important; align-items: flex-start !important; }
          .os-header-right { width: 100%; display: grid !important; grid-template-columns: 1fr 1fr; gap: 8px !important; }
        }

        @media (max-width: 640px) {
          .os-header-right { grid-template-columns: 1fr !important; }
          .os-anexos { grid-template-columns: repeat(3, 1fr) !important; }
          .os-shapes { grid-template-columns: repeat(3, 1fr) !important; }
        }

        .os-field:focus,
        .os-field select:focus,
        .os-field input:focus,
        .os-field textarea:focus {
          outline: none;
          box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
          border-color: #3b82f6 !important;
          background: #fff !important;
        }

        .os-scroll::-webkit-scrollbar { width: 6px; height: 6px; }
        .os-scroll::-webkit-scrollbar-thumb { background: rgba(15,23,42,0.15); border-radius: 999px; }

        @keyframes spin { 100% { transform: rotate(360deg); } }
      `}</style>

      {showQRModal && (
        <div style={styles.overlay}>
          <div style={styles.modalCard}>
            <h3 style={styles.modalTitle}>Câmera do celular</h3>
            <p style={styles.modalText}>Escaneie o QR Code para enviar fotos.</p>
            <div style={styles.qrBox}>
              <QRCodeSVG value={mobileCameraUrl} size={130} />
            </div>
            <button onClick={closeMobileCamera} style={styles.btnGhost}>Fechar</button>
          </div>
        </div>
      )}

      {compressing && (
        <div style={styles.overlay}>
          <div style={styles.modalCard}>
            <div style={styles.spinner}></div>
            <h3 style={styles.modalTitle}>Processando imagem</h3>
            <p style={styles.modalText}>{uploadMessage}</p>
            <div style={styles.progressBg}>
              <div style={{ ...styles.progressFill, width: `${uploadProgress}%` }}></div>
            </div>
          </div>
        </div>
      )}

      <div style={styles.topBar} className="os-header">
        <div>
          <div style={styles.kicker}>ORDEM DE SERVIÇO</div>
          <h2 style={styles.title}>Nova venda</h2>
        </div>

        <div style={styles.topBarRight} className="os-header-right">
          <div style={styles.statusCard}>
            <span style={styles.statusLabel}>WhatsApp Auto</span>
            <button
              type="button"
              onClick={() => update('statusmsg', form.statusmsg === 'Pendente' ? 'Enviada' : 'Pendente')}
              style={{
                ...styles.toggleBtn,
                ...(form.statusmsg === 'Enviada' ? styles.toggleBtnActive : {})
              }}
            >
              <Icons.Message />
              {form.statusmsg === 'Enviada' ? 'Enviar msg' : 'Não enviar'}
            </button>
          </div>

          <div style={styles.statusCard}>
            <span style={styles.statusLabel}>Status</span>
            <select
              style={styles.topSelect}
              value={form.status}
              onChange={(e) => update('status', e.target.value)}
            >
              {statusOptions.map((opt) => <option key={opt}>{opt}</option>)}
            </select>
          </div>
        </div>
      </div>

      <div style={styles.body} className="scroll-area os-scroll">
        {Object.keys(errors).length > 0 && (
          <div style={styles.errorBanner}>
            <Icons.Alert /> Existem campos obrigatórios pendentes.
          </div>
        )}

        <div style={styles.mainStack}>
          {/* SESSÃO COMPRADOR E DADOS DA EMPRESA */}
          <div style={styles.card}>
            <SectionTitle icon={<Icons.User />} title="Comprador" subtitle="Empresa, vendedor e cliente" />
            <div style={styles.grid2} className="os-grid-2">
              <Field label="Loja" required error={errors.loja}>
                <select className="os-field" style={{ ...styles.input, ...(errors.loja ? styles.inputError : {}) }} value={form.loja} onChange={(e) => update('loja', e.target.value)} disabled={loadingEmpresas}>
                  <option value="">{loadingEmpresas ? 'Carregando...' : 'Selecione a loja'}</option>
                  {empresas.filter((emp) => emp.ativo !== false).map((emp) => (
                    <option key={emp._id} value={emp.codigoLoja}>{emp.nome}</option>
                  ))}
                </select>
              </Field>

              <Field label="Vendedor" required error={errors.vendedor}>
                <select className="os-field" style={{ ...styles.input, ...(errors.vendedor ? styles.inputError : {}) }} value={form.vendedor} onChange={(e) => update('vendedor', e.target.value)} disabled={loadingUsuarios || !form.loja}>
                  <option value="">Selecione o vendedor</option>
                  {vendedoresDisponiveis.map((user) => <option key={user._id} value={user.nomeCompleto}>{user.nomeCompleto}</option>)}
                </select>
              </Field>

              <Field label="Nome do comprador" required error={errors.cliente} span2>
                <input className="os-field" style={{ ...styles.input, ...(errors.cliente ? styles.inputError : {}) }} value={form.cliente} onChange={(e) => update('cliente', e.target.value)} placeholder="Nome completo" />
              </Field>

              <Field label="CPF"><input className="os-field" style={styles.input} value={form.cpf} onChange={(e) => update('cpf', masks.cpf(e.target.value))} placeholder="000.000.000-00" maxLength={14} /></Field>
              <Field label="Nascimento"><input className="os-field" type="date" style={styles.input} value={form.dataNascimento} onChange={(e) => update('dataNascimento', e.target.value)} /></Field>
              <Field label="WhatsApp" required error={errors.whatsapp}><input className="os-field" style={{ ...styles.input, ...(errors.whatsapp ? styles.inputError : {}) }} value={form.whatsapp} onChange={(e) => update('whatsapp', masks.phone(e.target.value))} placeholder="(00) 00000-0000" /></Field>
              
              <div style={styles.grid2}>
                <Field label="Data da venda" required error={errors.dataCompra}><input className="os-field" type="date" style={{ ...styles.input, ...(errors.dataCompra ? styles.inputError : {}) }} value={form.dataCompra} onChange={(e) => update('dataCompra', e.target.value)} /></Field>
                <Field label="Entrega" required error={errors.dataEntrega}><input className="os-field" type="date" style={{ ...styles.input, ...(errors.dataEntrega ? styles.inputError : {}) }} value={form.dataEntrega} onChange={(e) => update('dataEntrega', e.target.value)} /></Field>
              </div>
            </div>

            {/* QUADRO DA EMPRESA RESTAURADO */}
            {empresaSelecionada && (
              <div style={styles.empresaCard}>
                <div style={styles.empresaCardHeader}>
                  <div style={styles.empresaName}>
                    <Icons.Building /> {empresaSelecionada.nome}
                  </div>
                  {empresaSelecionada.unidade ? (
                    <span style={styles.unitBadge}>{empresaSelecionada.unidade}</span>
                  ) : null}
                </div>

                <div style={styles.empresaInfoGrid}>
                  <div style={styles.empresaInfoItem}><Icons.Phone /> {empresaSelecionada.whatsapp || empresaSelecionada.telefone || '--'}</div>
                  <div style={styles.empresaInfoItem}><Icons.MapPin /> {empresaSelecionada.endereco || 'Endereço não informado'}</div>
                  <div style={styles.empresaInfoItem}><Icons.Building /> {empresaSelecionada.codigoLoja || '--'}</div>
                  <div style={styles.empresaInfoItem}><Icons.User /> {vendedoresDisponiveis.length} vendedor(es)</div>
                </div>
              </div>
            )}
          </div>

          {/* SESSÃO ENDEREÇO */}
          <div style={styles.card}>
            <SectionTitle icon={<Icons.MapPin />} title="Endereço" />
            <div style={styles.grid2} className="os-grid-2">
              <Field label="CEP"><input className="os-field" style={styles.input} value={form.cep} onChange={(e) => update('cep', masks.cep(e.target.value))} onBlur={checkCEP} placeholder="00000-000" maxLength={9} /></Field>
              <Field label="Número"><input className="os-field" style={styles.input} value={form.numero} onChange={(e) => update('numero', e.target.value)} placeholder="Nº" /></Field>
              <Field label="Logradouro" span2><input className="os-field" style={styles.input} value={form.endereco} onChange={(e) => update('endereco', e.target.value)} placeholder="Rua, avenida..." /></Field>
              <Field label="Bairro"><input className="os-field" style={styles.input} value={form.bairro} onChange={(e) => update('bairro', e.target.value)} /></Field>
              <div style={styles.grid2}>
                 <Field label="Cidade"><input className="os-field" style={styles.input} value={form.cidade} onChange={(e) => update('cidade', e.target.value)} /></Field>
                 <Field label="UF"><input className="os-field" style={styles.input} value={form.uf} onChange={(e) => update('uf', e.target.value)} /></Field>
              </div>
            </div>
          </div>

          {/* SESSÃO ITENS DO PEDIDO (COM MEDIDAS, ORIGEM, FORMATO, ETC) */}
          <div style={styles.card}>
            <SectionTitle icon={<Icons.Glasses />} title="Itens do pedido" subtitle="Receita, lente, armação e medidas" />

            {form.itens.map((item, index) => {
              const inputBaseIndex = index * 20;
              return (
                <div key={index} style={styles.itemCard}>
                  <div style={styles.itemCardHeader}>
                    <h4 style={styles.itemTitle}>Óculos {index + 1}</h4>
                    <div style={styles.itemActions} className="os-actions">
                      {index > 0 && (
                        <>
                          <button type="button" style={styles.btnMini} onClick={() => copiarDadosDoPrimeiroOculos(index)}><Icons.Copy /> Copiar</button>
                          <button type="button" style={styles.btnMiniDanger} onClick={() => removerOculos(index)}><Icons.Trash /> Remover</button>
                        </>
                      )}
                    </div>
                  </div>

                  <Field label="Paciente" required error={errors[`item_${index}_paciente`]}>
                    <input className="os-field" style={{ ...styles.input, ...(errors[`item_${index}_paciente`] ? styles.inputError : {}) }} value={item.paciente} onChange={(e) => updateItem(index, 'paciente', e.target.value)} placeholder="Nome de quem usará este óculos" />
                  </Field>

                  <div style={{ marginTop: 12 }}>
                    <div style={styles.subLabel}>Receita</div>
                    <div style={styles.receitaCard}>
                      <div style={styles.receitaHeader}>
                        <div style={{ width: 24 }}></div>
                        {['ESF', 'CIL', 'EIXO', 'DNP', 'ALT'].map((h) => <div key={h} style={styles.colHeader}>{h}</div>)}
                      </div>
                      <ReceitaRow label="OD" color="#2563eb" values={item.receita.od} baseIndex={inputBaseIndex} onChange={(f, v) => updateItem(index, `receita.od.${f}`, v)} onEnter={handleEnterNavigation} />
                      <div style={styles.rowDivider}></div>
                      <ReceitaRow label="OE" color="#dc2626" values={item.receita.oe} baseIndex={inputBaseIndex + 5} onChange={(f, v) => updateItem(index, `receita.oe.${f}`, v)} onEnter={handleEnterNavigation} />
                    </div>
                  </div>

                  <div style={{ ...styles.grid2, marginTop: 12 }} className="os-grid-2">
                     <Field label="Adição (+)">
                        <input data-idx={inputBaseIndex + 10} className="os-field" style={styles.input} value={item.receita.adicao} onChange={(e) => updateItem(index, 'receita.adicao', e.target.value)} onBlur={(e) => updateItem(index, 'receita.adicao', formatters.adicao(e.target.value))} placeholder="+0,00" />
                     </Field>
                     <Field label="Código CV (Lab)">
                        <input className="os-field" style={styles.input} value={item.cv} onChange={(e) => updateItem(index, 'cv', e.target.value)} placeholder="Controle" />
                     </Field>
                  </div>

                  <div style={styles.divisorAba}>Detalhes do Produto</div>

                  <div style={{ ...styles.grid2, marginBottom: 12 }} className="os-grid-2">
                    <Field label="Lente" required error={errors[`item_${index}_lente`]}>
                      <div style={styles.searchWrap}>
                        <input className="os-field" style={{ ...styles.input, ...(errors[`item_${index}_lente`] ? styles.inputError : {}) }} value={item.lente} onChange={(e) => handleLenteSearch(e.target.value, index)} onFocus={() => item.lente.length >= 2 && setShowLenteSuggestionsIndex(index)} placeholder="Buscar lente..." />
                        {isSearchingLente && showLenteSuggestionsIndex === index ? <div style={styles.miniLoader}></div> : <span style={styles.searchIcon}><Icons.Search /></span>}
                      </div>
                      {showLenteSuggestionsIndex === index && lenteSuggestions.length > 0 && (
                        <div style={styles.suggestions}>
                          {lenteSuggestions.map((sug) => <div key={sug._id} style={styles.suggestionItem} onClick={() => selectLente(sug, index)}><div style={styles.suggestionMain}>{sug.nome}</div></div>)}
                        </div>
                      )}
                    </Field>

                    <Field label="Armação (Ref/Marca)" required error={errors[`item_${index}_armacao`]}>
                      <div style={styles.searchWrap}>
                        <input className="os-field" style={{ ...styles.input, ...(errors[`item_${index}_armacao`] ? styles.inputError : {}) }} value={item.armacao} onChange={(e) => handleArmacaoSearch(e.target.value, index)} onFocus={() => item.armacao.length >= 2 && setShowSuggestionsIndex(index)} placeholder="Buscar armação..." />
                        {isSearchingStock && showSuggestionsIndex === index ? <div style={styles.miniLoader}></div> : <span style={styles.searchIcon}><Icons.Search /></span>}
                      </div>
                      {showSuggestionsIndex === index && armacaoSuggestions.length > 0 && (
                        <div style={styles.suggestions}>
                          {armacaoSuggestions.map((sug) => <div key={sug._id} style={styles.suggestionItem} onClick={() => selectArmacao(sug, index)}><div style={styles.suggestionMain}>{sug.marca} - {sug.ref}</div></div>)}
                        </div>
                      )}
                    </Field>
                  </div>

                  <div style={{ ...styles.grid2, marginBottom: 12 }} className="os-grid-2">
                    <Field label="Origem da Armação">
                       <select className="os-field" style={styles.input} value={item.origemArmacao} onChange={(e) => updateItem(index, 'origemArmacao', e.target.value)}>
                          <option>Ótica</option>
                          <option>Própria do Cliente</option>
                       </select>
                    </Field>
                    <Field label="Logística (Onde está?)">
                       <select className="os-field" style={styles.input} value={item.envioArmacao} onChange={(e) => updateItem(index, 'envioArmacao', e.target.value)}>
                          <option>Vai no malote</option>
                          <option>Fica na loja (Já na óptica)</option>
                          <option>Não enviar para lab (Apenas Lente)</option>
                       </select>
                    </Field>
                  </div>

                  <div style={styles.subLabel}>Medidas da Armação</div>
                  <div style={styles.grid4} className="os-grid-4">
                     <Field label="Aro"><input className="os-field" style={styles.inputMini} value={item.medidasArmacao.aro} onChange={(e) => updateItem(index, 'medidasArmacao.aro', e.target.value)} placeholder="00" /></Field>
                     <Field label="Ponte"><input className="os-field" style={styles.inputMini} value={item.medidasArmacao.ponte} onChange={(e) => updateItem(index, 'medidasArmacao.ponte', e.target.value)} placeholder="00" /></Field>
                     <Field label="Altura"><input className="os-field" style={styles.inputMini} value={item.medidasArmacao.altura} onChange={(e) => updateItem(index, 'medidasArmacao.altura', e.target.value)} placeholder="00" /></Field>
                     <Field label="Diagonal"><input className="os-field" style={styles.inputMini} value={item.medidasArmacao.diagonalMaior} onChange={(e) => updateItem(index, 'medidasArmacao.diagonalMaior', e.target.value)} placeholder="00" /></Field>
                  </div>

                  <div style={{...styles.subLabel, marginTop: 12}}>Formato da Armação</div>
                  <div style={styles.shapeGrid} className="os-shapes">
                     {formatos.map(({ id, label, Icon }) => {
                        const isSelected = item.formatoArmacao === id;
                        return (
                           <div key={id} onClick={() => updateItem(index, 'formatoArmacao', id)} style={isSelected ? styles.shapeCardActive : styles.shapeCard}>
                              <div style={styles.shapeIconWrap}><Icon /></div>
                              <span style={styles.shapeLabel}>{label}</span>
                           </div>
                        );
                     })}
                  </div>

                </div>
              );
            })}
            <button type="button" style={styles.btnAddItem} onClick={addNovoOculos}><Icons.Plus /> Adicionar óculos</button>
          </div>

          <div style={styles.card}>
             <SectionTitle icon={<Icons.Dollar />} title="Financeiro" />
             <div style={styles.grid2} className="os-grid-2">
                 <Field label="Valor total do pedido (R$)">
                    <input className="os-field" style={styles.inputStrong} value={form.valorTotal} onChange={(e) => update('valorTotal', e.target.value)} placeholder="0,00" />
                 </Field>
             </div>

             <div style={{ ...styles.financeWrap, marginTop: 12 }} className="os-finance">
                 <Field label="Forma de Pagto">
                    <select className="os-field" style={styles.input} value={novoPagamento.metodo} onChange={(e) => setNovoPagamento({ ...novoPagamento, metodo: e.target.value })}>
                       {metodosPagamento.map((m) => <option key={m}>{m}</option>)}
                    </select>
                 </Field>
                 {novoPagamento.metodo === 'Crédito' && (
                    <Field label="Parcelas"><input className="os-field" type="number" min="1" max="12" style={styles.input} value={novoPagamento.parcelas} onChange={(e) => setNovoPagamento({ ...novoPagamento, parcelas: e.target.value })} /></Field>
                 )}
                 <Field label="Valor pago"><input className="os-field" style={styles.input} value={novoPagamento.valor} onChange={(e) => setNovoPagamento({ ...novoPagamento, valor: e.target.value })} placeholder="0,00" /></Field>
                 <button type="button" style={styles.btnSecondary} onClick={addPayment}>Inserir</button>
             </div>

             <div style={styles.paymentList}>
                 {form.pagamentos.map((p) => (
                    <div key={p.id} style={styles.paymentItem}>
                       <div><div style={styles.paymentMethod}>{p.metodo} {p.parcelas > 1 ? `(${p.parcelas}x)` : ''}</div><div style={styles.paymentValue}>{formatCurrency(p.valor)}</div></div>
                       <button type="button" style={styles.iconBtnDanger} onClick={() => removePayment(p.id)}><Icons.Trash /></button>
                    </div>
                 ))}
             </div>
             
             <div style={styles.summaryBox}>
                <div style={styles.summaryRow}><span>Total</span><strong>{formatCurrency(valorTotalNum)}</strong></div>
                <div style={styles.summaryRow}><span>Recebido</span><strong style={{ color: '#16a34a' }}>{formatCurrency(totalPago)}</strong></div>
                <div style={styles.summaryDivider}></div>
                <div style={styles.summaryRow}><span>Saldo</span><strong style={{ color: restante > 0.01 ? '#dc2626' : '#16a34a' }}>{restante <= 0.01 ? 'QUITADO' : formatCurrency(restante)}</strong></div>
             </div>
          </div>

          <div style={styles.card}>
            <SectionTitle icon={<Icons.Camera />} title="Anexos / Receitas" />
            <div style={styles.anexoTop}>
               <button type="button" style={styles.btnGhostBlue} onClick={openMobileCamera}><Icons.Smartphone /> Celular</button>
               <button type="button" style={styles.btnGhost} onClick={addImageSlot}><Icons.Plus /> Espaço</button>
            </div>
            <div style={styles.photoGrid} className="os-anexos">
               {form.anexos.map((img, index) => (
                  <div key={index} style={styles.photoSlot}>
                     {img ? (
                        <><img src={img} alt="Anexo" style={styles.previewImg} /><button type="button" style={styles.removeImgBtn} onClick={() => removeImage(index)}><Icons.Trash /></button></>
                     ) : (
                        <label style={styles.uploadLabel}><Icons.Plus /><span style={styles.uploadText}>Adicionar</span><input type="file" accept="image/*" style={{ display: 'none' }} disabled={compressing} onChange={(e) => handleFileChange(index, e.target.files[0])} /></label>
                     )}
                  </div>
               ))}
            </div>
          </div>

          <div style={styles.card}>
            <SectionTitle icon={<Icons.FileText />} title="Observações" />
            <textarea className="os-field" style={styles.textArea} value={form.novoTextoRegistro} onChange={(e) => update('novoTextoRegistro', e.target.value)} placeholder="Anotações sobre a venda, exigências do cliente..." />
          </div>
        </div>
      </div>

      <div style={styles.footer} className="os-footer">
        <button type="button" style={styles.btnGhost} onClick={onCancel} disabled={loading}>Cancelar</button>
        <button type="button" style={styles.btnPrimary} onClick={handleSubmit} disabled={loading || compressing || loadingEmpresas || loadingUsuarios}>
          {loading ? 'Salvando...' : 'Finalizar pedido'}
        </button>
      </div>
    </div>
  );
}

const styles = {
  // Ajustado para ficar mais compacto (menor padding, borderRadius, fontes)
  shell: { display: 'flex', flexDirection: 'column', height: '100%', minHeight: '100vh', background: '#f8fafc', borderRadius: 16, overflow: 'hidden', border: '1px solid #e2e8f0' },
  topBar: { padding: '16px 20px', borderBottom: '1px solid #e2e8f0', background: 'linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 },
  kicker: { fontSize: 10, fontWeight: 800, letterSpacing: '.12em', color: '#2563eb', marginBottom: 4 },
  title: { margin: 0, fontSize: 20, color: '#0f172a' },
  topBarRight: { display: 'flex', gap: 8, alignItems: 'stretch' },
  statusCard: { background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, padding: '8px 12px', minWidth: 140, display: 'flex', flexDirection: 'column', gap: 6 },
  statusLabel: { fontSize: 10, fontWeight: 700, color: '#64748b', textTransform: 'uppercase' },
  toggleBtn: { border: '1px solid #dbeafe', background: '#eff6ff', color: '#2563eb', borderRadius: 8, padding: '6px 10px', fontSize: 11, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, cursor: 'pointer' },
  toggleBtnActive: { background: '#dcfce7', borderColor: '#bbf7d0', color: '#15803d' },
  topSelect: { border: '1px solid #e2e8f0', background: '#fff', borderRadius: 8, padding: '6px 8px', fontSize: 12, fontWeight: 600, color: '#0f172a' },
  body: { flex: 1, overflowY: 'auto', padding: 16 },
  errorBanner: { background: '#fef2f2', color: '#b91c1c', border: '1px solid #fecaca', borderRadius: 10, padding: '10px 12px', marginBottom: 14, display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, fontWeight: 700 },
  mainStack: { display: 'flex', flexDirection: 'column', gap: 14 },
  card: { background: '#fff', border: '1px solid #e2e8f0', borderRadius: 14, padding: 14, boxShadow: '0 4px 14px rgba(15,23,42,0.03)' },
  sectionTitleWrap: { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 },
  sectionIcon: { width: 28, height: 28, borderRadius: 8, background: '#eff6ff', color: '#2563eb', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  sectionTitle: { fontSize: 14, fontWeight: 800, color: '#0f172a' },
  sectionSubtitle: { fontSize: 11, color: '#64748b', marginTop: 2 },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 },
  grid4: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8 },
  fieldWrap: { display: 'flex', flexDirection: 'column', gap: 4 },
  span2: { gridColumn: '1 / -1' },
  label: { fontSize: 10, color: '#64748b', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.05em' },
  labelError: { color: '#b91c1c' },
  input: { width: '100%', border: '1px solid #dbe4f0', background: '#f8fafc', borderRadius: 8, padding: '8px 10px', fontSize: 13, color: '#0f172a', fontWeight: 600, boxSizing: 'border-box' },
  inputMini: { width: '100%', border: '1px solid #dbe4f0', background: '#f8fafc', borderRadius: 8, padding: '8px', fontSize: 12, color: '#0f172a', fontWeight: 600, boxSizing: 'border-box', textAlign: 'center' },
  inputError: { border: '1.5px solid #ef4444', background: '#fef2f2' },
  inputStrong: { width: '100%', border: '1px solid #dbe4f0', background: '#f8fafc', borderRadius: 8, padding: '10px 12px', fontSize: 15, color: '#0f172a', fontWeight: 800, boxSizing: 'border-box' },
  miniLoader: { width: 12, height: 12, border: '2px solid #dbeafe', borderTop: '2px solid #2563eb', borderRadius: '50%', animation: 'spin 1s linear infinite' },
  
  // Estilo do Quadro da Empresa - Compactado
  empresaCard: { marginTop: 12, background: 'linear-gradient(180deg, #f8fbff 0%, #f8fafc 100%)', border: '1px solid #dbeafe', borderRadius: 10, padding: 12 },
  empresaCardHeader: { display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginBottom: 8 },
  empresaName: { display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 800, color: '#0f172a' },
  unitBadge: { background: '#dbeafe', color: '#1d4ed8', borderRadius: 999, padding: '4px 8px', fontSize: 10, fontWeight: 800 },
  empresaInfoGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 },
  empresaInfoItem: { display: 'flex', alignItems: 'center', gap: 4, fontSize: 11, color: '#475569', fontWeight: 600 },

  itemCard: { border: '1px solid #e2e8f0', background: '#fbfdff', borderRadius: 12, padding: 12, marginBottom: 12 },
  itemCardHeader: { display: 'flex', justifyContent: 'space-between', gap: 10, alignItems: 'center', marginBottom: 10 },
  itemTitle: { margin: 0, fontSize: 14, color: '#0f172a' },
  itemActions: { display: 'flex', gap: 6 },
  btnMini: { display: 'inline-flex', alignItems: 'center', gap: 4, border: '1px solid #dbeafe', background: '#eff6ff', color: '#1d4ed8', borderRadius: 8, padding: '6px 8px', fontSize: 11, fontWeight: 700, cursor: 'pointer' },
  btnMiniDanger: { display: 'inline-flex', alignItems: 'center', gap: 4, border: '1px solid #fecaca', background: '#fef2f2', color: '#dc2626', borderRadius: 8, padding: '6px 8px', fontSize: 11, fontWeight: 700, cursor: 'pointer' },
  subLabel: { fontSize: 10, color: '#64748b', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.05em', marginBottom: 6 },
  divisorAba: { margin: '14px 0', borderBottom: '1px dashed #cbd5e1', color: '#475569', fontSize: 11, fontWeight: 700, paddingBottom: 4 },
  receitaCard: { border: '1px solid #e2e8f0', borderRadius: 10, overflow: 'hidden' },
  receitaHeader: { display: 'flex', background: '#f8fafc', padding: '6px 8px', borderBottom: '1px solid #e2e8f0' },
  colHeader: { flex: 1, textAlign: 'center', fontSize: 10, color: '#64748b', fontWeight: 800 },
  receitaRow: { display: 'flex', alignItems: 'center', gap: 4, padding: '6px 8px' },
  olhoBadge: { width: 24, height: 20, borderRadius: 6, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 800 },
  tdInput: { flex: 1, minWidth: 0, border: '1px solid #dbe4f0', background: '#fff', borderRadius: 6, padding: '6px 4px', textAlign: 'center', fontSize: 11, fontWeight: 700, color: '#0f172a' },
  rowDivider: { height: 1, background: '#e2e8f0' },
  searchWrap: { position: 'relative', display: 'flex', alignItems: 'center' },
  searchIcon: { position: 'absolute', right: 10, color: '#94a3b8' },
  suggestions: { marginTop: 4, border: '1px solid #e2e8f0', borderRadius: 8, overflow: 'hidden', background: '#fff', boxShadow: '0 4px 12px rgba(15,23,42,0.08)', maxHeight: 150, overflowY: 'auto' },
  suggestionItem: { padding: 8, cursor: 'pointer', borderBottom: '1px solid #f1f5f9' },
  suggestionMain: { fontSize: 12, fontWeight: 700, color: '#0f172a' },
  shapeGrid: { display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 6 },
  shapeCard: { border: '1px solid #e2e8f0', background: '#fff', borderRadius: 8, padding: '8px 4px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, cursor: 'pointer', transition: 'all 0.2s' },
  shapeCardActive: { border: '2px solid #2563eb', background: '#eff6ff', borderRadius: 8, padding: '7px 3px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, cursor: 'pointer' },
  shapeIconWrap: { color: '#475569' },
  shapeLabel: { fontSize: 9, fontWeight: 700, color: '#334155', textTransform: 'uppercase' },
  btnAddItem: { width: '100%', border: '1.5px dashed #93c5fd', background: '#eff6ff', color: '#2563eb', borderRadius: 10, padding: '10px 12px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, fontSize: 12, fontWeight: 800, cursor: 'pointer' },
  financeWrap: { display: 'flex', gap: 8, alignItems: 'end' },
  btnSecondary: { border: 'none', background: '#2563eb', color: '#fff', borderRadius: 8, padding: '8px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer', height: 35 },
  paymentList: { marginTop: 10, display: 'flex', flexDirection: 'column', gap: 8 },
  paymentItem: { border: '1px solid #e2e8f0', background: '#f8fafc', borderRadius: 8, padding: '8px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  paymentMethod: { fontSize: 11, fontWeight: 800, color: '#334155' },
  paymentValue: { fontSize: 12, fontWeight: 800, color: '#0f172a' },
  iconBtnDanger: { width: 28, height: 28, borderRadius: 8, border: '1px solid #fecaca', background: '#fef2f2', color: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' },
  summaryBox: { marginTop: 12, border: '1px solid #e2e8f0', background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)', borderRadius: 12, padding: 12 },
  summaryRow: { display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#334155', fontWeight: 600 },
  summaryDivider: { height: 1, background: '#e2e8f0', margin: '8px 0' },
  anexoTop: { display: 'flex', gap: 8, marginBottom: 10 },
  btnGhostBlue: { border: '1px solid #bfdbfe', background: '#eff6ff', color: '#2563eb', borderRadius: 8, padding: '8px 10px', fontSize: 11, fontWeight: 800, display: 'inline-flex', alignItems: 'center', gap: 4, cursor: 'pointer' },
  btnGhost: { border: '1px solid #e2e8f0', background: '#fff', color: '#334155', borderRadius: 8, padding: '8px 10px', fontSize: 11, fontWeight: 800, display: 'inline-flex', alignItems: 'center', gap: 4, cursor: 'pointer' },
  photoGrid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8 },
  photoSlot: { aspectRatio: '1 / 1', borderRadius: 10, border: '1.5px dashed #cbd5e1', background: '#f8fafc', overflow: 'hidden', position: 'relative' },
  previewImg: { width: '100%', height: '100%', objectFit: 'cover' },
  removeImgBtn: { position: 'absolute', top: 4, right: 4, width: 24, height: 24, borderRadius: 6, border: 'none', background: 'rgba(15,23,42,0.65)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' },
  uploadLabel: { width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4, color: '#64748b', cursor: 'pointer' },
  uploadText: { fontSize: 10, fontWeight: 700 },
  textArea: { width: '100%', minHeight: 80, border: '1px solid #dbe4f0', background: '#f8fafc', borderRadius: 10, padding: '10px', fontSize: 13, color: '#0f172a', fontWeight: 500, resize: 'vertical', boxSizing: 'border-box' },
  footer: { padding: 14, borderTop: '1px solid #e2e8f0', background: '#fff', display: 'flex', justifyContent: 'flex-end', gap: 8 },
  btnPrimary: { border: 'none', background: '#0f172a', color: '#fff', borderRadius: 8, padding: '10px 14px', fontSize: 12, fontWeight: 800, cursor: 'pointer', minWidth: 150 },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.35)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 },
  modalCard: { width: 260, background: '#fff', borderRadius: 16, padding: 18, border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', alignItems: 'center' },
  modalTitle: { margin: 0, fontSize: 16, fontWeight: 800, color: '#0f172a' },
  modalText: { margin: '6px 0 0', fontSize: 12, color: '#64748b', textAlign: 'center' },
  qrBox: { marginTop: 12, border: '1px solid #e2e8f0', borderRadius: 12, padding: 10, background: '#fff' },
  spinner: { width: 22, height: 22, border: '3px solid #dbeafe', borderTop: '3px solid #2563eb', borderRadius: '50%', animation: 'spin 1s linear infinite', marginBottom: 12 },
  progressBg: { width: '100%', height: 6, background: '#e2e8f0', borderRadius: 999, marginTop: 12, overflow: 'hidden' },
  progressFill: { height: '100%', background: '#2563eb', borderRadius: 999 }
};